import api from '../api/axios';

// Throttle: avoid flooding the backend if the same error fires repeatedly.
const lastSent = new Map();
const SESSION_MAX = 30;
let sentCount = 0;

function readToken() {
  try {
    return localStorage.getItem('token');
  } catch {
    return null;
  }
}

export function reportError({ message, stack, component_stack, url }) {
  if (!readToken()) return;
  const key = String(message || '').slice(0, 200);
  const now = Date.now();
  const last = lastSent.get(key) || 0;
  if (now - last < 10000) return;
  if (sentCount >= SESSION_MAX) return;
  lastSent.set(key, now);
  sentCount++;

  const payload = {
    message: message || 'Unknown error',
    stack: stack || '',
    component_stack: component_stack || '',
    url: url || (typeof window !== 'undefined' ? window.location.href : ''),
  };

  try {
    api.post('/client-errors', payload).catch(() => {});
  } catch {
    // Error reporting must never throw or break the app.
  }
}

// Also keep a small local ring buffer so the last few errors survive in the
// browser for immediate inspection (e.g. "Copy details" or a quick console check).
export function persistErrorLocally(error) {
  try {
    const entry = {
      ts: new Date().toISOString(),
      message: String(error?.message || 'Unknown error'),
      stack: String(error?.stack || ''),
      url: typeof window !== 'undefined' ? window.location.href : '',
    };
    const log = JSON.parse(localStorage.getItem('err_log') || '[]');
    log.push(entry);
    localStorage.setItem('err_log', JSON.stringify(log.slice(-5)));
  } catch {
    // ignore
  }
}
